import { HttpClient } from '../services';
import {  ConnectionInfo, ConnectionAccessDto, CreateConnection, AllConnectionsInfo, GetTablesInfo, RecordsSearchQuery,
    RecordsInfoResponse, CreateCatalogType, CatalogInfo, ApiPromise, ApiResponse, PiRequestQueryResponse, PiRequestQuery, NewConnectionMetadata, NiFiManagedNodesResponse, AwsConnectionType, AuditRequestHistoryType, queryRequest, queryResponse, DeepSqlConnectionInfo,
    AllWorflowByUser} from './types';
import { API } from '../../constants/settings';
import { makeSearchParams } from '../../helpers/makeSearchParams';
import queryString from 'query-string';
import { DeleteCustomComponentResponse } from '../new-custom-component';
import { WitsmlHandler } from './witsml-handler';
import { InstallationLogsDataType, NiFiSinkData } from '@pages/admin/nifi_management/types';
import isEmpty from 'lodash/isEmpty'
import { AI_QUERY, AI_RESPONSE, AI_QUERY_LANGGRAPH } from '@pages/data-explorer/gen-ai/types';
import { AxiosPromise, AxiosResponse } from 'axios';
import { PiRequestInfo } from '@pages/data-browser/pi-managed-requests-table';

class DataSourceHandlerClass extends WitsmlHandler {
    CreateConnection(link: string, data: CreateConnection, callback: (arg0: ConnectionInfo[]) => any, errorHandlerCallback: any){
        HttpClient.Post('Create a connection', link + '/v2/connection', data, callback, errorHandlerCallback);
    }

    UpdateConnection(link: string, connectionId: string, data: CreateConnection, callback: (arg0: ConnectionInfo[]) => any, errorHandlerCallback: any){
        HttpClient.Put('Create a connection', link + `/v2/connection/${connectionId}`, data, callback, errorHandlerCallback);
    }

    DeleteConnection(link: string, connectionId: number, callback: (arg0: DeleteCustomComponentResponse) => any, errorHandlerCallback: any){
        HttpClient.Delete('Create a connection', link + `/v2/connection/${connectionId}`, callback, errorHandlerCallback);
    }

    GetAllConnectionsInfo(link: string, callback: (arg0: AllConnectionsInfo) => any) {
        HttpClient.Get('Get all connections', link + '/v2/connection-metadata', callback);
    }

    GrantConnectionAccess(link: string, data: { connectionId: number; userIds: string[]; accessLevel: 'READ' }, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Grant connection access', link + '/v2/connection-access/grant', data, callback, errorHandlerCallback);
    }

    RevokeConnectionAccess(link: string, data: { connectionId: number; userIds: string[] }, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Revoke connection access', link + '/v2/connection-access/revoke', data, callback, errorHandlerCallback);
    }

    GetConnectionAccessList(link: string, connectionId: number, callback: ApiResponse<ConnectionAccessDto[]>, errorHandlerCallback: any) {
        HttpClient.Get('Get connection access list', link + `/v2/connection-access/${connectionId}/users`, callback, errorHandlerCallback);
    }

    DeleteDagAirflow(link: string, id: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Delete Dag Airflow', link + `/v1/dags/${id}`, callback, errorHandlerCallback);
    }

    GetRefreshUpdates(link: string, callback: (arg0: any) => any,errorHandlerCallback: any) {
        HttpClient.Get('Get Refresh Updates', link + '/v2/node/patches/process', callback,errorHandlerCallback);
    }

    GetDatabaseTypeList(link: string, callback: (arg0: NewConnectionMetadata) => any) {
        HttpClient.Get('Get Database Type List', link + '/v2/connection-type-metadata', callback);
    }

    GetTables(link: string, data: GetTablesInfo, callback: (arg0: string[]) => any,errorHandlerCallback: any) {
        const searchQuery = makeSearchParams(data);
        HttpClient.Get('Get Database Type List', link + `/v2/tables${searchQuery}`, callback,errorHandlerCallback);
    }

    GetRecords(link: string, searchQuery: RecordsSearchQuery, callback: (arg0: RecordsInfoResponse) => any){
        const _searchQuery = queryString.stringify(searchQuery, { encode: true });
        HttpClient.Get('Get Database Type List', link + `/v2/records?${_searchQuery}`, callback);
    }

    // GetDatabasesOfAConnection(connectionId: number, callback: (arg0: string[]) => void){
    //     HttpClient.Get('Get all connections', API.databrowserUrl + `/v2/databases?connectionId=${connectionId}`, callback);
    // }

    // CreateCatalog(data: CreateCatalogType): ApiPromise<CatalogInfo> {
    //     return HttpClient.PostPromise( API.databrowserUrl + '/v2/catalogs', data);
    // }
    
    // GetCatalogs(callback: (arg0: any) => any) {
    //     HttpClient.Get('Get all connections', API.databrowserUrl + '/v2/catalogs', callback);
    // }

    GetPIServer(link:string, connectionId: number, callback: (arg0: any) => void, error: (arg0: any) => void ) {
        HttpClient.Post('Get PI Server List', link + `/v2/osi-servers?connectionId=${connectionId}`, {
            'attr_type' : 'PI_Server',
            'site_id': 2
        }, callback, error);
    }

    GetPIData(link:string, connectionId: number, data: any, callback: (arg0: any) => void, error: (arg0: any) => void){
        HttpClient.Post('Get PI Data', link + `/v2/osi-data?connectionId=${connectionId}`, data, callback, error);
    }

    // GetContainersListInAzureBlobConn(connectionId: number, callback: ApiResponse<string[]>) {
    //     HttpClient.Get('Get PI Data', API.databrowserUrl + `/v2/azureblob/listofcontainers?connectionId=${connectionId}`, callback);
    // }

    // GetAzureBlobsOfContainer(connectionId: number, containerName: string, callback: ApiResponse<string[]>) {
    //     HttpClient.Get('Get PI Data', API.databrowserUrl + `/v2/azureblob/listofblobs?connectionId=${connectionId}&containerName=${containerName}`, callback);
    // }

    GetEdgeNodes(link:string, callback: ApiResponse<any>) {
        HttpClient.Get('GetEdgeNodes', link + '/v2/node', callback)
    }

    GetSinkNodes(link:string, callback: ApiResponse<any>) {
        HttpClient.Get('GetSinkNodes', link + '/v2/sink/', callback)
    }

    // GetNodesOfNiFiManaged(callback: ApiResponse<NiFiManagedNodesResponse>) {
    //     HttpClient.Get('GetNodesOfNiFiManaged', API.databrowserUrl + '/v2/node-metadata', callback)
    // }

    GetRequestsOfPiNode(link:string, nodeId: string, searchQuery: PiRequestQuery, callback: PiRequestQueryResponse, errorCallback?: any) {
        const _searchQuery = queryString.stringify(searchQuery, { encode: true, skipNull: true });
        HttpClient.Get('GetRequestsOfPiNode', link + `/v2/request/pagination/${nodeId}?${_searchQuery}`, callback, errorCallback)
    }

    CreatePiNodeRequest(link:string, nodeName: string, requestName: string, stringifiedJson: string, sinkName:string, sinkKind:string,modelRequestId:number|null, nodeKind: string, connectionName: string, triggers: Record<string, any>, callback: ApiResponse<any>, enableNotificationOnFailure?: boolean, notificationEmails?: string[], enableNotificationOnSuccess?: boolean) {
        HttpClient.Post('Create Node Request', link + '/v2/request', {
            nodeName,
            json: stringifiedJson,
            state: "new",
            requestName,
            sinkName,
            sinkKind,
            modelRequestId,
            nodeKind,
            connectionName,
            enableNotificationOnFailure: !!enableNotificationOnFailure,
            enableNotificationOnSuccess: !!enableNotificationOnSuccess,
            notificationEmails: notificationEmails || [],
            ...triggers
        }, callback)
    }

    SubmitPiRequest(link:string, requestId: number, callback: ApiResponse<any>,errorHandlerCallback?: any) {
        HttpClient.Put('Submit Node Pi Request', link + '/v2/request/' + requestId + '/submit', {}, callback,errorHandlerCallback)
    }

    StopPiRequest(link:string, requestId: number, callback: ApiResponse<any>) {
        HttpClient.Put('Submit Node Pi Request', link + '/v2/request/' + requestId + '/stop', {}, callback)
    }

    DeletePiRequest(link:string, requestId: number, callback: ApiResponse<any>) {
        HttpClient.Delete('Delete Node Pi Request', link + '/v2/request/' + requestId, callback)
    }

    DownloadPiRequestJson(link:string, requestId: number, callback: ApiResponse<any>) {
        HttpClient.Get('Submit Node Pi Request', link + '/v2/request/' + requestId + '/download', callback)
    }

    UpdatePiRequestJson(link:string, requestId: string, requestName: string, stringifiedJson: string, sinkName:string, sinkKind:string, triggers: Record<string, any>, callback: ApiResponse<any>, enableNotificationOnFailure?: boolean, notificationEmails?: string[], enableNotificationOnSuccess?: boolean) {
        HttpClient.Put('Update Node Pi Request Json', link + '/v2/request/' + requestId + '/json', {
            json: stringifiedJson,
            requestName,
            sinkName,
            sinkKind,
            enableNotificationOnFailure: !!enableNotificationOnFailure,
            enableNotificationOnSuccess: !!enableNotificationOnSuccess,
            notificationEmails: notificationEmails || [],
            ...triggers
        }, callback)
    }

    ClonePiRequest(link:string, requestId: number, callback: ApiResponse<any>) {
        HttpClient.Put('Submit Node Pi Request', link + '/v2/request/' + requestId + '/clone', {}, callback)
    }

    // DeleteEdgeByID(requestId: number, callback: ApiResponse<any>) {
    //     HttpClient.Delete('Delete Edge Request', API.databrowserUrl + '/v2/node/' + requestId, callback)
    // }

    CreateEdgeNode(link:string, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Create a Edge Connection', link + '/v2/node', data, callback, errorHandlerCallback);
    }
    
    UpdateEdgeNode(link:string, nodeName: string, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Update Edge Connection', link + '/v2/node/' + nodeName , data, callback, errorHandlerCallback);
    }

    DeleteEdgeNode(link:string, nodeName: string, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Create a Edge Connection', link + '/v2/node/' + nodeName, callback, errorHandlerCallback);
    }

    CreateSinkNode(link:string, data: NiFiSinkData, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Create a Sink Connection', link + '/v2/sink/', data, callback, errorHandlerCallback);
    }

    UpdateSinkNode(link:string, sinkName: string, data: NiFiSinkData, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Update Sink Connection', link + '/v2/sink/' + sinkName , data, callback, errorHandlerCallback);
    }

    DeleteSinkNode(link:string, sinkName: string, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Delete a Sink Connection', link + '/v2/sink/' + sinkName, callback, errorHandlerCallback);
    }

    DownloadEdgeCertificate(link:string, data:  any) {
        if(data.nodeName){
            return HttpClient.GetBlob(link + `/v2/${data.nodeName}/generate-config`);
        }else{
            return HttpClient.GetBlob(link + `/v2/${data.parentNode}/generate-config?nodeScaleName=${data.nodeScaleName}`);
        }   
    }
    GetNodeNames(link:string, type: string, callback: ApiResponse<any>) {
        HttpClient.Get('Submit Node Pi Request', link + '/v2/node-name?nodeKind=' + type, callback);
    }

    GetSinkType(link:string, callback: ApiResponse<any>) {
        HttpClient.Get('Submit Node Pi Request',link + '/v2/sink-type', callback);
    }

    GetConnectionBySinkKind(link:string, sinkKInd: string, callback: (arg0: string[]) => void){
        HttpClient.Get('Get all connections by sinkKind', link + `/v2/connections?database_type=${sinkKInd}`, callback);
    }

    GetNodeKind(link:string, callback: ApiResponse<any>) {
        HttpClient.Get('Submit Node Pi Request',link + '/v2/node-kinds', callback);
    }

    CloneConnectionRequest(link:string, connectionId: number, callback: ApiResponse<string>) {
        HttpClient.Get('Submit Clone Connection Request', link + '/v2/connection/clone?connectionId='+ connectionId, callback);
    }

    GetAWSConnectionList(link:string, callback: ApiResponse<AwsConnectionType[]>) {
        HttpClient.Get('Get AWS Connection List Request', link + '/v1/datasource?fs_type=s3', callback);
    }
    
    GetAuditReqHistory(link:string, requestId:string,callback: ApiResponse<AuditRequestHistoryType[]>) {
        HttpClient.Get('Get Audit Request History', link + '/v2/audit/request/'+ requestId, callback);
    }

    GetViewReqJson(link:string, requestId:string,callback: ApiResponse<PiRequestInfo>) {
        HttpClient.Get('Get View Request Json', link + '/v2/request/'+ requestId, callback);
    }
    
    GetProgressReqHistory(link:string, requestId:string,callback: ApiResponse<any[]>) {
        HttpClient.Get('Get Process Request History', link + `/v2/request/${requestId}/progress`, callback);
    }
    
    SaveQueryResponse(link:string, data: queryRequest, callback?:any, errorHandlerCallback?: any) {
        HttpClient.Post('Save Query Response', link + '/v2/query', data, callback, errorHandlerCallback);
    }

    GetAllQueryResponse(link:string, page:number,callback: ApiResponse<queryResponse>) {
        HttpClient.Get('Get All Query Response', link + '/v2/query?page='+ page+'&size=5', callback);
    }

    GetDatabaseTableWithSchema(link:string, connectionId: number) {
        return HttpClient.GetPromise(link + `/v2/database-meta-data/${connectionId}`);
    }

    GenerativeAINew(link: string, connectionId: number,prompt: string, settings?: any) {
        return HttpClient.PostPromise(link + `/schema/${connectionId}/query_gpt_sql`, {
            query:prompt,
            ...settings
        })
    }

    GenerativeAICygnet(link: string, connectionId: number,prompt: string) {
        return HttpClient.PostPromise(link + `/schema/${connectionId}/query_cygnet?ss_wford=true`, {
            query:prompt,
        })
    }
    OpenAI(link: string, prompt: string, settings: any) {
        return HttpClient.PostPromise(link + `/v2/openai/azure/query`, {
            prompt,
            ...settings
        })
    }
    DeepSQLChat(link: string, db_id: number, session_id: string, data: AI_QUERY,username:string): AxiosPromise<AI_RESPONSE> {
        if(!isEmpty(session_id)) {
            return HttpClient.PostPromise(link + `/v2/schema/${db_id}/gpt/?session_id=${session_id}&username=${username}`, data)
        }
        return HttpClient.PostPromise(link + `/v2/schema/${db_id}/gpt/?username=${username}`, data)
    }

    DeepSQLChatLanggraph(link: string, db_id: number, session_id: string, data: AI_QUERY_LANGGRAPH,username:string): AxiosPromise<AI_RESPONSE> {
        if(!isEmpty(session_id)) {
            return HttpClient.PostPromise(link + `/v2/langgraph/${db_id}/?session_id=${session_id}&username=${username}`, data)
        }
        return HttpClient.PostPromise(link + `/v2/langgraph/${db_id}/?username=${username}`, data)
    }

    CygnetSQLChat(link: string, session_id: string, data: AI_QUERY): AxiosPromise<AI_RESPONSE> {
        if(!isEmpty(session_id)) {
            return HttpClient.PostPromise(link + `/v2/schema/cygnet_custom/gpt/?session_id=${session_id}`, data)
        }
        return HttpClient.PostPromise(link + `/v2/schema/cygnet_custom/gpt/`, data)
    }

    GetLogs(link: string, query_uuid: string) {
        return HttpClient.GetPromise(link + `/v2/query_logs/?query_uuid=${query_uuid}`)
    }

    GetSchemaForiegn(link: string, db_id: number) {
        return HttpClient.GetPromise(link + `/v2/${db_id}/schema_foreign_key/`)
    }

    GetSchemaTable(link: string, db_id: number) {
        return HttpClient.GetPromise(link + `/v2/${db_id}/schema_table_aug/`)
    }

    GetSchemaColumn(link: string, db_id: number) {
        return HttpClient.GetPromise(link + `/v2/${db_id}/schema_column_aug/`)
    }

    PostSchemaForeign(link: string, db_id: number, data: any) {
        return HttpClient.PostPromise(link + `/v2/${db_id}/schema_foreign_key/`, data)
    }

    PostSchemaTable(link: string, db_id: number, data: any) {
        return HttpClient.PostPromise(link + `/v2/${db_id}/schema_table_aug/`, data)
    }

    PostSchemaColumn(link: string, db_id: number, data: any) {
        return HttpClient.PostPromise(link + `/v2/${db_id}/schema_column_aug/`, data)
    }

    DownloadLogs(link: string, session_id: string) {
        return HttpClient.GetPromise(link + `/v2/chat_history?session_id=${session_id}`)
    }

    GetSchemaIndex(link: string, db_id: number) {
        return HttpClient.GetPromise(link + `/schema/custom/${db_id}/indexing`)
    }

    GetVirtualViewList(link: string, db_id: number) {
        return HttpClient.GetPromise(link + `/v2/virtual_view_list/?database_id=${db_id}`)
    }

    GetAllDeepSqlConnectionsInfo(link: string, callback: (arg0: DeepSqlConnectionInfo[]) => any,errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get all deepsql connections', link + '/databases/', callback,errorCallback);
    }
 
    GetDeepSqlDatabaseTableWithSchema(link: string, connectionId: number) {
        return HttpClient.GetPromise(link + `/tables/?database_id=${connectionId}`);
    }

    PostVirtualView(link: string, data: any,callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        return HttpClient.Post("Post Virtual View",link + `/v2/virtual_view/`, data,callback,errorCallback);     
    }

    Feedback(link: string, query_uuid: string, impression: boolean, comments: string, sessionId: string ) {
        return HttpClient.PostPromise(link + `/v2/feedback/`, {
            query_uuid,
            positive: impression,
            comments,
            session_uuid: sessionId
        })
    }

    GetNifiGraphData(link: string, nodeName: string, time: string, type: string,  callback: ApiResponse<any>) {
        HttpClient.Get('GetNifiGraphData', link + `/v2/node/status/changes/${nodeName}?type=${type}&filter=${time}`, callback)
    }

    GetNifiMetricsEventsRaw(link: string, nodeName: string, fromMs: number, toMs: number, callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Nifi Metrics Events Raw', link + `/v2/nifi/metrics/events/raw?nodeName=${nodeName}&fromMs=${fromMs}&toMs=${toMs}`, callback, errorCallback)
    }

    ShowHideFeedBack(link: string, username: string, callback: ApiResponse<any>) {
        HttpClient.Get('Show or Hide Feedback', link+`/get-user-config/?username=${username}`, callback) 
    }

    ShowPatches(link: string, patchName: string, command: string, callback: ApiResponse<any>) {
        HttpClient.Get('Show Patches', link+`/v2/node/patches?nodeName=${patchName}&command=${command}`, callback) 
    }

    ShowInstallationLogs(link: string, nodeName: string, callback: ApiResponse<InstallationLogsDataType[]>,errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Show Installation Logs', link+`/v2/request/${nodeName}/patch-logs`, callback,errorCallback) 
    }

    UpdatePatches(link: string, data: any, callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Post('Update Patches', link+`/v2/request/patch/create-submit`, data, callback, errorCallback) 
    }

    DeleteScaleNodes(link: string, nodeName: string, nodeScaleName: string, callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Delete('Delete Scale Node', link+`/v2/node/${nodeName}?nodeScaleName=${nodeScaleName}`, callback, errorCallback)
    }

    scaledNode(link: string, nodeName: string, callback: ApiResponse<any>) {
        HttpClient.Get('Show Patches', link+`/v2/scalednodes/${nodeName}`, callback) 
    }

    CreateModel(link: string, data: any, callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Post('Create Model', link+`/v1/classes/create`, data, callback, errorCallback) 
    }

    CreateInstances(link: string, data: any, callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Post('Create Instance', link+`/v2/instances/create`, data, callback, errorCallback) 
    }

    getModelList(link: string,  callback: ApiResponse<any>) {
        HttpClient.Get('Get Models', link+`/v1/classes/list`, callback) 
    }

    getInstancesList(link: string,  callback: ApiResponse<any>) {
        HttpClient.Get('Get Instances', link+`/v2/instances/list`, callback) 
    }

    fetchInstancesDetails(link: string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Fetch Instances Details', link+`/v2/instances/get/${id}`, callback) 
    }

    UpdateInstancesDetails(link:string, id: number, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Update Instances', link + `/v2/instances/update/${id}` , data, callback, errorHandlerCallback);
    }

    deleteInstances(link:string, id: number, callback: ApiResponse<any>) {
        HttpClient.Delete('Delete Model', link + `/v2/instances/delete?id=${id}` , callback)
    }
    
    fetchInstancesAuditHistoryDetails(link: string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Fetch Instances Audit History Details', link+`/v2/instances/get/audit-history/${id}`, callback) 
    }

    deleteInstancesGroup(link:string, groupInstanceName: string, callback: ApiResponse<any>) {
        HttpClient.Delete('Delete Model', link + `/v2/instances/delete?groupInstanceName=${groupInstanceName}` , callback)
    }

    fetchModelDetails(link: string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Fetch Model', link+`/v1/classes/get/${id}`, callback) 
    }

    fetchModelProjectDetails(link: string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Fetch Model Project Details', link+`/v1/projects/${id}`, callback) 
    }

    fetchProjectDetails(link: string, callback: ApiResponse<any>) {
        HttpClient.Get('Fetch Projects', link+`/v1/projects`, callback) 
    }

    UpdateModelDetails(link:string, id: number, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Update Model', link + `/v1/classes/update/${id}` , data, callback, errorHandlerCallback);
    }

    deleteModel(link:string, id: number, callback: ApiResponse<any>) {
        HttpClient.Delete('Delete Model', link + `/v1/classes/delete/${id}` , callback)
    }

    deleteProject(link:string, id: number, dropSchema: boolean, callback: ApiResponse<any>) {
        if(dropSchema)
        HttpClient.Delete('Delete Project', link + `/v1/projects/${id}?dropSchema=${dropSchema}` , callback)
        else
        HttpClient.Delete('Delete Project', link + `/v1/projects/${id}` , callback)
    }

    fetchTagsFromCsv(link: string, data: any,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Post('Fetch Tags From Csv', link+`/v2/instances/extract-tags`,data, callback,errorCallback) 
    } 

    getHierarchyData(link: string,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Hierarchy Data', link+`/v2/data-model`, callback, errorCallback) 
    }

    getProjectHierarchyData(link: string, projectId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Project Hierarchy Data', link+`/v2/data-model/${projectId}`, callback, errorCallback) 
    }

    getProjectEntityData(link: string, projectId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Project Entity Data', link+`${projectId}/classes/names`, callback, errorCallback) 
    }

    getEntityInstanceData(link: string, modelName: string, hierarchyId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Entity Instance Data', link+`${modelName}/${hierarchyId}`, callback, errorCallback) 
    } 

    getStaticPropertyData(link: string, modelName: string, instanceName: string, hierarchyId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Static Property Data', link+`${modelName}/instance-static/${instanceName}/${hierarchyId}`, callback, errorCallback) 
    }

    getEntityPropertyData(link: string, modelName: string, instanceName: string, hierarchyId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Entity Property Data', link+`${modelName}/instance-entity/${instanceName}/${hierarchyId}`, callback, errorCallback) 
    } 

    getIndexProperty(link: string, modelName: string, instanceName: string, hierarchyId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Index Property Data', link+`${modelName}/instance-indexes/${instanceName}/columns/${hierarchyId}`, callback, errorCallback) 
    }

    getIndexPropertyData(link: string, modelName: string, instanceName: string, indexName: string, hierarchyId: number,  callback: ApiResponse<any>, errorCallback: ApiResponse<AxiosResponse>) {
        HttpClient.Get('Get Index Property Data', link+`${modelName}/instance-indexes/${instanceName}/series/${indexName}/${hierarchyId}`, callback, errorCallback) 
    }
    
    CreateHierarchy(link:string, projectId:string, formData: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Create a Hierarchy', link + `/v2/data-model/create?projectId=${projectId}`, formData, callback, errorHandlerCallback);
    }

    CreateProject(link:string, formData: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Create a Project', link + '/v1/projects', formData, callback, errorHandlerCallback);
    }

    CreateProjectSchema(link:string,id:string|null, formData: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Create a Project Schema', link + `/schemas?projectId=${id}`, formData, callback, errorHandlerCallback);
    }

    UpdateHierarchy(link:string, formData: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Update a Hierarchy', link + '/v2/data-model/update', formData, callback, errorHandlerCallback);
    }
    
    GetModelRequest(link: string, id: number, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Model Request', link + `/v2/request/model/${id}`, callback, errorHandlerCallback)
    }

    UpdateModelRequest(link:string, id: string, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Update Model Request', link + `/v2/request/model/${id}`, data, callback, errorHandlerCallback)
    }
 
    DeleteModelRequest(link:string, id: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Delete Model Request', link + `/v2/request/model/${id}` , callback, errorHandlerCallback)
    }

    DeleteHierarchy(link:string, id: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Delete Hierarchy', link + `/v2/data-model/${id}` , callback, errorHandlerCallback)
    }

    ViewCsvFileMetadata(link:string, hierarchyId: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Get('View Csv File Metadata', link + `/v2/records?hierarchyId=${hierarchyId}` , callback, errorHandlerCallback)
    }

    ViewCsvFileMetadataByHierarchyName(link:string, hierarchyId: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Get('View Csv File Metadata By Hierarchy Name', link + `/v2/instances/hierarchy/${hierarchyId}?page=0&size=1000000000&sortBy=instanceName&sortDir=asc` , callback, errorHandlerCallback)
    }
    SaveCsvFileMetadata(link:string, hierarchyId: number, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Put('Save Csv File Records', link + `/v2/update-records?hierarchyId=${hierarchyId}`, data, callback, errorHandlerCallback)
    }

    SaveCsvFileMetadataForKnowledgeGraph(link:string, knowledgeGraphId: number, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Save Csv File Records For Knowledge Graph', link + `/v2/instances/batch?knowledgeGraphId=${knowledgeGraphId}`, data, callback, errorHandlerCallback)
    }

    DeleteCsvFileMetadata(link:string, hierarchyId: number, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Delete Csv File Records', link + `/v2/delete-records?hierarchyId=${hierarchyId}`,data, callback, errorHandlerCallback)
    }

    DeleteCsvFileMetadataForKnowledgeGraph(link:string, data: any, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Post('Delete Csv File Records For Knowledge Graph', link + `/v2/instances/batch/delete`,data, callback, errorHandlerCallback)
    } 
    GetPropertiesByInstanceIdForKnowledgeGraph(link:string, instanceId: string, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Get('Get Properties By Instance Id For Knowledge Graph', link + `/v2/instances/${instanceId}/properties`, callback, errorHandlerCallback)
    }

    GetAssetRevisions(link: string, assetId: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Asset Revisions', link + `/v2/assets/audit/${assetId}`, callback, errorHandlerCallback);
    }

    GetAssetRevisionsForKnowledgeGraph(link: string, assetId: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Asset Revisions For Knowledge Graph', link + `/v2/instances/audit/${assetId}`, callback, errorHandlerCallback);
    }

    RevertAssetRevision(link: string, assetId: string, revision: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Revision', link + `/v2/assets/audit/${assetId}/revert/${revision}`, {}, callback, errorHandlerCallback);
    }
    
    RevertAssetRevisionForKnowledgeGraph(link: string, assetId: string, revision: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Revision for Knowledge Graph', link + `/v2/instances/audit/${assetId}/revert/${revision}`, {}, callback, errorHandlerCallback);
    }

    RevertAssetTableToDate(link: string,id: number, date: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Table To Date', link + `/v2/assets/audit/revert?date=${date}&id=${id}`, {}, callback, errorHandlerCallback);
    }
    
    RevertAssetTableToDateForKnowledgeGraph(link: string,id: number, date: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Table To Date For Knowledge Graph', link + `/v2/instances/audit/revert?date=${date}&id=${id}`, {}, callback, errorHandlerCallback);
    }

    RevertAssetTableToDatePreview(link: string,id: number, date: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Table To Date', link + `/v2/assets/audit/revert/preview?date=${date}&id=${id}`, {}, callback, errorHandlerCallback);
    }

    RevertAssetTableToDatePreviewForKnowledgeGraphPreview(link: string,id: number, date: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Table To Date Preview For Knowledge Graph', link + `/v2/instances/audit/revert/preview?date=${date}&id=${id}`, {}, callback, errorHandlerCallback);
    }

    RevertAssetRevisionPreview(link: string, assetId: string, revision: string, hierarchy_id: number, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Revision', link + `/v2/assets/audit/${assetId}/revert/${revision}/preview/${hierarchy_id}`, {}, callback, errorHandlerCallback);
    }

    RevertAssetRevisionPreviewForKnowledgeGraph(link: string, assetId: string, revision: string, hierarchy_id: number, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Post('Revert Asset Revision For Knowledge Graph', link + `/v2/instances/audit/${assetId}/revert/${revision}/preview/${hierarchy_id}`, {}, callback, errorHandlerCallback);
    }

    GetRoots(link: string,nodeName:string,  serverName:string, databaseName:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Roots', link + `/v2/afstructure/roots?nodeName=${nodeName}&serverName=${serverName}&databaseName=${databaseName}`, callback, errorHandlerCallback);
    }
 
    GetRDBMSRoots(link: string,nodeName:string,  serverName:string, databaseName:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Rdbms Roots', link + `/v2/afstructure/rdbms-metadata?nodeName=${nodeName}&serverName=${serverName}&databaseName=${databaseName}`, callback, errorHandlerCallback);
    }

    GetProjectAssetHierarchyRoots(link: string,hierarchyId:number, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Project Asset Hierarchy Roots', link + `/v2/roots?hierarchyId=${hierarchyId}`, callback, errorHandlerCallback);
    }

    GetRootElementById(link: string,id:string,nodeName:string,   serverName:string, databaseName:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Roots', link + `/v2/afstructure/elements/${id}?nodeName=${nodeName}&serverName=${serverName}&databaseName=${databaseName}`, callback, errorHandlerCallback);
    }

    GetProjectHierarchyAttributes(link: string,path:string,hierarchyId:number, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get project Hierarchy attributes', link + `/v2/attributes?path=${path}&hierarchyId=${hierarchyId}`, callback, errorHandlerCallback);
    }
    CreateHierarchyRequest(link:string,payload:any, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Post('Create Hierarchy Request', link + '/v2/request/create-submit',payload, callback,errorHandlerCallback)
    }
    
    PublishHierarchyRequest(link:string,payload:any, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Post('Create Hierarchy Request', link + '/v2/request/model',payload, callback,errorHandlerCallback)
    }

    GetAllModelRequests(link: string,nodeName:string,connectionName:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Model Requests', link + `/v2/request/model?nodeName=${nodeName}&connectionName=${connectionName}`, callback, errorHandlerCallback);
    }
    CreateHierarchyRequestForAf(link:string,payload:any, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Post('Create Hierarchy Request For Af', link + '/v2/request/hierarchy/create-submit',payload, callback,errorHandlerCallback)
    }
    GetAllWorkflows(link: string, callback: ApiResponse<AllWorflowByUser>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Workflows', link + `/v1/workflow/all/by-user`, callback, errorHandlerCallback);
    }

    HandlePullPushHierarchy(link:string, id:number, action:string, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Get('Handle Pull Push Hierarchy', link + `/v2/publish/${id}/${action}`, callback,errorHandlerCallback)
    }

    CheckPullPushHierarchy(link:string, hierarchyName:string, id:number, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Get('Check Pull Push Hierarchy', link + `/v2/data-model/workflow/validate/${hierarchyName}/${id}`, callback,errorHandlerCallback)
    }

    ShareHierarchy(link:string, data: any, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Post('Share Hierarchy', link + `/v2/data-model/share`,data, callback,errorHandlerCallback)
    }

    ishierarchyShared(link:string, id:number|string, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Get('Check Pull Push Hierarchy', link + `/v2/data-model/share/${id}`, callback,errorHandlerCallback)
    }

    getAccessSharedList(link:string, id:number|string, callback: ApiResponse<any>,errorHandlerCallback?:any) {
        HttpClient.Get('Get Access Shared List', link + `/v2/data-model/share/${id}/access-list`, callback,errorHandlerCallback)
    }

    GetAllDags(link: string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get DAGs', link + `/v2/dags/dropdown`, callback, errorHandlerCallback);
    }

    GetStartEndTimeRangeList(link: string,payload:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Start End Time Range List', link + `/v2/afstructure/next?${payload}`, callback, errorHandlerCallback);
    }

    GetPipoints(link: string,nodeName:string, serverName:string, databaseName:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Pipoints', link + `/v2/afstructure/pipoints?nodeName=${nodeName}&serverName=${serverName}&databaseName=${databaseName}`, callback, errorHandlerCallback);
    }
    
    GetSearchRoots(link: string,nodeName:string, serverName: string, databaseName: string, keyword:string, callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get Roots', link + `/v2/afstructure/search?nodeName=${nodeName}&serverName=${serverName}&databaseName=${databaseName}&keyword=${keyword}`, callback, errorHandlerCallback);
    }
    
    openMetricLogs(link: string, nodeName:string, type: string,appName: string, callback: ApiResponse<any>, errorCallback: any) {
        HttpClient.Post('Open Metric Logs', link+`/grafana/deploy?edgeName=${nodeName}&type=${type}&appName=${appName}`,{}, callback, errorCallback) 
    }

    DeleteMetricLogs(link:string, nodeName: string, type: string, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Delete('Delete Metric Logs', link + `/grafana/delete?edgeName=${nodeName}&type=${type}`, callback, errorHandlerCallback)
    }

    AddNewClass(link: string, projectId:string, data: any, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Post('Add New Class', link + `/v1/classes/with-attributes?projectId=${projectId}`, data, callback, errorHandlerCallback);
    }
    updateClass(link: string, data: any,id:number, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Put('Update Class', link + `/asset/attributes?modelId=${id}`, data, callback, errorHandlerCallback);
    }

    GetNewClasses(link: string,projectId:number,callback: ApiResponse<any>, errorHandlerCallback?: any) {
        HttpClient.Get('Get New Classes', link + `/v1/classes?projectId=${projectId}`, callback, errorHandlerCallback);
    }

    ViewProject(link:string, projectId: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Get('View Project', link + `/schemas?projectId=${projectId}` , callback, errorHandlerCallback)
    }

    GetProject(link:string, projectId: number, callback: ApiResponse<any>, errorHandlerCallback: any) {
        HttpClient.Get('Get Project', link + `/v1/projects/${projectId}` , callback, errorHandlerCallback)
    }
    deleteClasses(link:string, id: number, dropTable: boolean, callback: ApiResponse<any>) {
        if(dropTable)
        HttpClient.Delete('Delete Classes', link + `/v1/classes/${id}?dropTable=${dropTable}` , callback)
        else
        HttpClient.Delete('Delete Classes', link + `/v1/classes/${id}` , callback)
    }

    GetConnectionType(link:string,type: string, callback: ApiResponse<any>) {
        HttpClient.Get('GetConnection', link + `/v1/datasource?database_type=${type}`, callback)
    }

    GetTableName(link:string, connectionName: string, callback: ApiResponse<any>) {
        HttpClient.Get('GetTableName', link + `/v1/datasource/get/${connectionName}/tables?pattern=`, callback)
    }

    GetFsType(link:string, fsType: string, callback: ApiResponse<any>) {
        HttpClient.Get('GetFsType', link + `/v1/datasource?fs_type=${fsType}`, callback)
    }

    CloneProjects(link: string, projectId: number, callback: ApiResponse<any>, errorCallback: any) {
        HttpClient.Post('Clone Projects', link+`/v1/projects/${projectId}/clone`,{}, callback, errorCallback) 
    }

    ExportProject(link: string, projectId: number, callback: ApiResponse<any>) {
        HttpClient.Get('Export Project', link + `/v1/projects/${projectId}/export/download`, callback)
    }

    ImportProject(link: string, formData: any, callback: ApiResponse<any>,errorCallback:any) {
        HttpClient.Post('Import Project', link+`/v1/projects/import/upload`, formData, callback, errorCallback) 

    }

    ExportHierarchy(link: string, hierarchyId: number, callback: ApiResponse<any>) {
        HttpClient.Get('Export Hierarchy', link + `/v1/owl/export/data-model/${hierarchyId}`, callback)
    }

    //DEMO PURPOSE
    assignPermission(link: string, data: any,id:number, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Put('Assign Permission', link + `/v1/projects/${id}/permissions`, data, callback, errorHandlerCallback);
    }

    getPermission(link: string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Get Permission', link + `/v1/projects/${id}/permissions`, callback)
    }

     getClassVersions(link:string, id: number, callback: ApiResponse<any>) {
        HttpClient.Get('Get Class Versions', link + `/v2/class/audit/class/${id}/revisions` , callback)
    }

     updateClassVersion(link: string,modelId:number,revisionNumber:number, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Get('Update Class Version', link + `/v2/class/audit/class/${modelId}/revision/${revisionNumber}`, callback, errorHandlerCallback);
    }

    revertClassVersion(link: string,modelId:number,revisionNumber:number, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Post('Revert Class Version', link + `/v2/class/audit/class/${modelId}/revert/${revisionNumber}`, {}, callback, errorHandlerCallback);
    }
    
    getAttributeVersions(link:string, attributeId: number, callback: ApiResponse<any>) {
        HttpClient.Get('Get Attribute Versions', link + `/v2/class/audit/class-attribute/${attributeId}/revisions` , callback)
    }

    revertAttributeVersion(link: string,attributeId:number,revisionNumber:number, callback: ApiResponse<any>, errorHandlerCallback: any){
        HttpClient.Post('Revert Attribute Version', link + `/v2/class/audit/class-attribute/${attributeId}/revert/${revisionNumber}`, {}, callback, errorHandlerCallback);
    }
}

const DataSourceHandler = new DataSourceHandlerClass();

export { DataSourceHandler };